<template>
  <div class="loading">
    <div class="fa-2x">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    serviceId() {
      return this.$store.state.serviceId;
    },
    user() {
      return this.$store.state.user;
    }
  },
  created() {
    if (this.$route.query.continue) {
      const dec = decodeURIComponent(
        this.$route.query.continue.replace(/\+/g, " ")
      );
      window.location.href = decodeURI(dec + `&redirect_uri=`);
    }

    if (this.user) this.$router.push({ name: "myaccount" });

    this.$router.push({ name: "signin" });
  }
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
}
</style>
